import { createContext, useState, useContext } from 'react';

const GlobalModalsContext = createContext();

export const GlobalModalsProvider = ({ children }) => {
  const [modals, setModals] = useState({});

  const openModal = (modalName, props = null) => {
    // First close all existing modals
    const closedModals = {};
    Object.keys(modals).forEach(key => {
      closedModals[key] = { isOpen: false, props: null };
    });
    setModals({
      ...closedModals,
      [modalName]: {
        isOpen: true,
        props
      }
    });
  };
  const closeModal = (modalName) => {
    setModals(prev => ({
      ...prev,
      [modalName]: {
        isOpen: false,
        props: null
      }
    }));
  };
  const closeAllModals = () => {
    const newModals = {};
    Object.keys(modals).forEach(key => {
      newModals[key] = { ...modals[key], isOpen: false };
    });
    setModals(newModals);
  };
  return (
    <GlobalModalsContext.Provider value={{ modals, openModal, closeModal, closeAllModals }}>
      {children}
    </GlobalModalsContext.Provider>
  );
};

export const useGlobalModals = () => useContext(GlobalModalsContext);